import React from "react"

export type TextProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLParagraphElement>,
  HTMLParagraphElement
>

export const TextBase = ({ children, className, ...props }: TextProps) => {
  return (
    <p className={`font-inter ${className ? className : ""}`} {...props}>
      {children}
    </p>
  )
}

export const LegalBodyTextRegular = ({
  children,
  className,
  ...props
}: TextProps) => {
  return (
    <TextBase
      className={`text-size14 font-normal !leading-6 ${className ? className : ""}`}
      {...props}
    >
      {children}
    </TextBase>
  )
}

export const BodyTextRegular = ({
  children,
  className,
  ...props
}: TextProps) => {
  return (
    <TextBase
      className={`text-size14 font-normal ${className ? className : ""}`}
      {...props}
    >
      {children}
    </TextBase>
  )
}

export const BodyTextSemibold = ({
  children,
  className,
  ...props
}: TextProps) => {
  return (
    <TextBase
      className={`text-size14 font-semibold ${className ? className : ""}`}
      {...props}
    >
      {children}
    </TextBase>
  )
}

export const BodyTextMedium = ({
  children,
  className,
  ...props
}: TextProps) => {
  return (
    <TextBase
      className={`text-size14 font-medium ${className ? className : ""}`}
      {...props}
    >
      {children}
    </TextBase>
  )
}

export const BodySubtextNormal = ({
  children,
  className,
  ...props
}: TextProps) => {
  return (
    <TextBase
      className={`text-size12 font-normal ${className ? className : ""}`}
      {...props}
    >
      {children}
    </TextBase>
  )
}

export const BodySubtextSemibold = ({
  children,
  className,
  ...props
}: TextProps) => {
  return (
    <TextBase
      className={`text-size12 font-semibold ${className ? className : ""}`}
      {...props}
    >
      {children}
    </TextBase>
  )
}

export const BodySubtextMedium = ({
  children,
  className,
  ...props
}: TextProps) => {
  return (
    <TextBase
      className={`text-size12 font-medium ${className ? className : ""}`}
      {...props}
    >
      {children}
    </TextBase>
  )
}

export const BodySubtextWide = ({
  children,
  className,
  ...props
}: TextProps) => {
  return (
    <TextBase
      className={`text-size12 font-normal tracking-[1px] ${className ? className : ""}`}
      {...props}
    >
      {children}
    </TextBase>
  )
}

export const BodySubtextMiniSemibold = ({
  children,
  className,
  ...props
}: TextProps) => {
  return (
    <TextBase
      className={`text-size10 font-semibold ${className ? className : ""}`}
      {...props}
    >
      {children}
    </TextBase>
  )
}

export const BodySubtextMiniMedium = ({
  children,
  className,
  ...props
}: TextProps) => {
  return (
    <TextBase
      className={`text-size10 font-medium ${className ? className : ""}`}
      {...props}
    >
      {children}
    </TextBase>
  )
}
